import script from "./CerrarCajaView.vue?vue&type=script&setup=true&lang=js"
export * from "./CerrarCajaView.vue?vue&type=script&setup=true&lang=js"

import "./CerrarCajaView.vue?vue&type=style&index=0&id=b9879b68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9879b68"]])

export default __exports__